

/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE now in sefvices pushnotes
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/
/***********************************
 * OBSOLETE OBSOLETE OBSOLETE OBSOLETE
***********************************/







//import Vue from 'vue'
//import { pushNotifications } from "../../services/PushNotifications.js";

// initialise pushnotes with phusnotes plugin
export function init_pushnotes(){
  
 /*
  // should run after login...
   // get device registration id for push notes
   pushNotifications.init().then(data=>{
        
    // set registration id
    pushNotifications.regID=data.registrationId;

  //commit('STORE_USER_SETTING',{key:"registrationId",val:data.registrationId});
  // store in user settings probabely
}).catch(()=>{
  //commit('STORE_USER_SETTING',{key:"registrationId",val:0});
  Vue.$toaster.toast("language.no_push_plugin");
  // do an alert
}).finally(()=>{
  // no matter if push notes are enabled or disabled allow app to start
  // login with previous stored credentials
  
})
*/
   
}